<template>
    <div>
        <div  class="text-h5 f-s-22 text-center font-weight-bold" v-html="$t('campaign_version_three.graph_header')"></div>
        <v-row no-gutters="" class="mt-7">
            <v-col cols="2">
                <div class="position-relative mb-7" :style="'height:'+(parseInt(maxHeight)+12)+'px'">
                    <template v-for="item in graphYItems">
                        <div class="graph-y" :style="{bottom: item.bottom +'px'}">{{item.title}}</div>
                    </template>
                </div>
            </v-col>
            <v-col cols="10">
                <div class="position-relative" :style="'height:'+parseInt(maxHeight)+'px'">
                    <div class="graph-x-0"></div>
                    <template v-for="dashed in graphYItems">
                        <div class="graph-y-dashed" :style="{bottom: dashed.bottom +'px'}"></div>
                    </template>
                    <template v-for="(otherG,index) in items.other">
                        <div :class="index === 0?'graph-first':''"
                             class="graph-other rounded d-flex align-center justify-center text-white text-caption font-weight-medium"
                             :style="{
                                      height:(parseInt(otherG.price)/25/heightLocaleFactor - (index === 0?2:4*heightLocaleFactor))+'px',
                                      bottom:(bottomValue(items.other,index)/25/heightLocaleFactor + (index === 0?0:2))+'px'}">
                          {{otherG.title}}
                        </div>
                    </template>
                    <template v-for="(novaG,index) in items.nova">
                        <div :class="index === 0?'graph-first':''"
                             class="graph-nova rounded d-flex align-center justify-center text-white text-caption font-weight-medium"
                             :style="{
                                      height:(parseInt(novaG.price)/25/heightLocaleFactor - (index === 0?2:4*heightLocaleFactor))+'px',
                                      bottom:(bottomValue(items.nova,index)/25/heightLocaleFactor + (index === 0?0:2))+'px'}">
                          {{novaG.title}}
                        </div>
                    </template>
                </div>
                <v-row no-gutters="" class="pt-3">
                    <v-col col="6">
                        <div class="text-body-2 text-black font-weight-medium text-center">{{ $t('campaign_version_three.graph_Other_installers') }}</div>
                    </v-col>
                    <v-col col="6">
                        <v-img src="/img/logo.svg" :height="20"></v-img>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <div class="text-overline font-italic text-black text-transform-none mb-3">{{ $t('campaign_version_three.graph_note') }}</div>
        <div class="text-body-1 font-weight-bold">
            {{ $t('campaign_version_three.graph_list_header') }}
        </div>
        <v-list lines="two" bg-color="transparent" density="compact" class="pb-2">
            <v-list-item class="px-0 py-2 custom-list-item">
                <template v-slot:prepend>
                    <v-icon color="success" icon="mdi-check" size="x-small" class="mr-2 opacity-1"></v-icon>
                </template>
                <v-list-item-subtitle class="text-body-2 opacity-1 text-black" v-html="$t('campaign_version_three.graph_list_item_1')"></v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="px-0 py-2 custom-list-item">
                <template v-slot:prepend>
                    <v-icon color="success" icon="mdi-check" size="x-small" class="mr-2 opacity-1"></v-icon>
                </template>
                <v-list-item-subtitle class="text-body-2 opacity-1 text-black" v-html="$t('campaign_version_three.graph_list_item_2')"></v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="px-0 py-2 custom-list-item">
                <template v-slot:prepend>
                    <v-icon color="success" icon="mdi-check" size="x-small" class="mr-2 opacity-1"></v-icon>
                </template>
                <v-list-item-subtitle class="text-body-2 opacity-1 text-black" v-html="$t('campaign_version_three.graph_list_item_3')"></v-list-item-subtitle>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import numberHelper from "../../plugins/numberHelper";

export default {
    name: "Graph",
    data() {
        return {
            items: {
                other: [
                    {
                        title: this.$t('campaign_version_three.graph_Material'),
                        price: parseInt(this.$t('campaign_version_three.graph_Material_other_price')),
                    },
                    {
                        title: this.$t('campaign_version_three.graph_Installation'),
                        price: parseInt(this.$t('campaign_version_three.graph_Installation_other_price')),
                    },
                    {
                        title: this.$t('campaign_version_three.graph_Sales commission'),
                        price: parseInt(this.$t('campaign_version_three.graph_Sales commission_other_price')),
                    },
                    {
                        title: this.$t('campaign_version_three.graph_Inspection'),
                        price: parseInt(this.$t('campaign_version_three.graph_Inspection_other_price')),
                    },
                ],
                nova:[
                    {
                        title: this.$t('campaign_version_three.graph_Material'),
                        price: parseInt(this.$t('campaign_version_three.graph_Material_our_price')),
                    },
                    {
                        title: this.$t('campaign_version_three.graph_Installation'),
                        price: parseInt(this.$t('campaign_version_three.graph_Installation_our_price')),
                    },
                    {
                        title: this.$t('campaign_version_three.graph_Inspection'),
                        price: parseInt(this.$t('campaign_version_three.graph_Inspection_our_price')),
                    },
                ],
            },
        };
    },
    computed: {
      heightLocaleFactor() {
        return  process.env.MIX_APP_LOCALE === 'pl' ? 3 : 1;
      },
        maxHeight() {
            let nova = 0;
            let other = 0;
            this.items.nova.map((iN) => {
                nova += iN.price;
            })
            this.items.other.map((item) => {
                other += item.price;
            })
            return Math.max(nova,other)/(25*this.heightLocaleFactor);
        },
        graphYItems() {
            let items = [];

            for (let i = 1; i <= parseInt(this.maxHeight / 100); i++) {
                items[i-1] = {
                    title: this.$numberHelper.formatMoneyAsString(i*2500*this.heightLocaleFactor),
                    // title: this.$t('campaign_version_three.graph_currency')+ (i*2500),
                    bottom: i*100,
                };
            }
            return items;
        }
    },
    methods: {
        bottomValue(items, index) {
            let value = 0;
            for(let i = 0; i < index; i++) {
                value += items[i].price;
            }
            return value;
        },
    }
}
</script>

<style scoped>

</style>
